import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { AutoUnsubscribe } from '../../../fw/decoractors/AutoUnsubscribe';
import {ChosenPercentage} from "./models/ChosenPercentage";
import {FormBuilder, FormGroup} from "@angular/forms";

@Component({
    selector: 'price-change-percentage',
    template: require('./price-change-percentage.component.html'),
    styles: [require('./price-change-percentage.component.css')]
})
@AutoUnsubscribe()

export class PriceChangePercentageComponent implements OnInit {
    @Input() dialog: DialogRef;
    @Output() chosenPercentage = new EventEmitter<ChosenPercentage>();
    roundItems: Array<{ text: string, value: number }> = [
        { text: "1", value: 1 },
        { text: "5", value: 5 },
        { text: "10", value: 10 },
        { text: "20", value: 20 },
        { text: "100", value: 100 }
    ];
    form: FormGroup;

    constructor(private fb: FormBuilder) {}

    ngOnInit() {
        this.form = this.fb.group({
            percentage: 0,
            round: 1
        });
    }

    btnCancelClicked(event) {
        this.closeWindow(false);
    }

    btnSaveClicked(event) {
        this.chosenPercentage.emit({
            percentage: this.form.get('percentage').value,
            round: this.form.get('round').value
        });
        this.closeWindow(true);
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-cashreg/price-change-percentage.component.ts